import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import useDspDetails from 'src/views/pages/dsp-payment/hooks/useGetWalletDetails';
import { BASE_URL } from '../../config/constant';
import { useAmzDspContext } from 'src/contexts/AmzDspContext';
import useApi from 'src/hooks/useApi';
import services from 'src/api/service';

const DspGuard = ({ children }) => {
  const { rechargeDspAccount: dspAccount } = useDspDetails();
  const selectedProfile = JSON.parse(sessionStorage.getItem('selectedProfileId'));

  const { amzDspState, amzDspDispatch } = useAmzDspContext();
    const doGetWalletBalance = useApi(services.postService);

  useEffect(() => {
    // if wallet details have not been fetched yet, fetch it
    if(dspAccount?.dspId && !amzDspState?.walletDetails?.wallet_id){
      doGetWalletBalance.request({
        url: '/dsp/wallet-list',
        nodeAPI: 1,
        payload: {
          dspId: dspAccount?.dspId
        }
      });
    }
  }, [dspAccount, amzDspState?.walletDetails?.wallet_id]);

  useEffect(() => {
    const { loading, data } = doGetWalletBalance;
    if (!loading && data && data?.success === true) {
      if(data?.data?.wallet_balance || data?.data?.wallet_credits) {
        const totalCredits = Object.values(data?.data?.wallet_credits || {}).reduce((sum, credit) => sum + (Number(credit) || 0), 0);
        const walletBalance = (Number(data?.data?.wallet_balance) || 0) + totalCredits;
        amzDspDispatch({ type: 'UPDATE_WALLET_BALANCE', payload: walletBalance });
      }
      const filteredWalletDetails = {
        wallet_id: data?.data?._id,
        minimum_amount: data?.data?.minimum_amount,
        currency: data?.data?.currency,
        hector_fees_percentage: data?.data?.hector_fees_percentage,
        agency_fees_percentage: data?.data?.agency_fees_percentage,
        paymentMethod: data?.data?.paymentMethod,
        ...(data?.data?.agencyWallet && { agency_wallet: data?.data?.agencyWallet }),
        displaySettings: data?.data?.agencyWallet?.displaySettings ?? { commissionShow: false, commissionMask: false, maskValue: 0 },
        dspClientName: data?.data?.dspClientName,
        pauseCampaigns: data?.data?.pauseCampaigns
      };
      amzDspDispatch({ type: 'UPDATE_WALLET_DETAILS_DATA', payload: filteredWalletDetails });
    } else if (!loading && data && data?.success === false) {
      amzDspDispatch({ type: 'UPDATE_WALLET_BALANCE', payload: 0 });
    }
  }, [doGetWalletBalance.loading]);

  // Redirect if no DSP account is available
  if (!dspAccount?.dspId && (!selectedProfile?.dsp || selectedProfile?.dsp?.length === 0)) {
    return <Redirect to={BASE_URL} />;
  }

  return <React.Fragment>{children}</React.Fragment>;
};

export default DspGuard;
